import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { BenchmarkPairConfigImpl } from "../model/impl/BenchmarkPairConfigImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class BenchmarkPairConfigImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: BenchmarkPairConfigImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.bmCode != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPairConfigImplEncoder.fidTypeMap.get(1),
        false,
        encodable.bmCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.base != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPairConfigImplEncoder.fidTypeMap.get(2),
        false,
        encodable.base,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.nonBase != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPairConfigImplEncoder.fidTypeMap.get(3),
        false,
        encodable.nonBase,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.warningLevel != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPairConfigImplEncoder.fidTypeMap.get(4),
        false,
        encodable.warningLevel,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.alertLevel != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPairConfigImplEncoder.fidTypeMap.get(5),
        false,
        encodable.alertLevel,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.spawnedCcyCd != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPairConfigImplEncoder.fidTypeMap.get(6),
        false,
        encodable.spawnedCcyCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.fwdWarningLevel != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPairConfigImplEncoder.fidTypeMap.get(7),
        false,
        encodable.fwdWarningLevel,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.fwdAlertLevel != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPairConfigImplEncoder.fidTypeMap.get(8),
        false,
        encodable.fwdAlertLevel,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPairConfigImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.sessionOnly != null) {
      this.baseEncoder.writeStartFid(10010, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPairConfigImplEncoder.fidTypeMap.get(10010),
        false,
        encodable.sessionOnly,
        streamout,
      );
      this.baseEncoder.writeEndFid(10010, streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "java.lang.String"],
    [3, "java.lang.String"],
    [4, "java.math.BigDecimal"],
    [5, "java.math.BigDecimal"],
    [6, "java.lang.String"],
    [7, "java.math.BigDecimal"],
    [8, "java.math.BigDecimal"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: BenchmarkPairConfigImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPairConfigImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.bmCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPairConfigImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.base = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPairConfigImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.nonBase = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPairConfigImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.warningLevel = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPairConfigImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.alertLevel = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPairConfigImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.spawnedCcyCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPairConfigImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.fwdWarningLevel = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPairConfigImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.fwdAlertLevel = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPairConfigImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPairConfigImplEncoder.fidTypeMap.get(10010),
            streamin,
          );
          encodable.sessionOnly = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return BenchmarkPairConfigImplEncoder.fidTypeMap.has(fid);
  }
}
